<template>
    <u-btn-text-rounded v-bind="$attrs" color="secondary" @click="$emit('click')">
        <template v-for="(_, slotName) in $slots" #[slotName]>
            <slot :name="slotName" />
        </template>
    </u-btn-text-rounded>
</template>

<script>
import UBtnTextRounded from "@/components/publish/styles/buttons/u-btn-text-rounded.vue";

export default {
    props: {},
    components: {
        UBtnTextRounded,
    },
    data: () => {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
